import { useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {BrowserRouter} from "react-router-dom";
import {initializeI18nAndThenAppendCustomerSpecificStylesheet, clearLocalStorageForUser} from "./lib/Utils";
import RouterComponent from "./components/RouterComponent";
import ConnectionLost from "./components/ConnectionLost";
import { ThemeProvider,createTheme } from "@mui/material/styles";
import CssBaseLine from '@mui/material/CssBaseline';
import { APP_DARK_PURPLE_COLOR, APP_ENGLISH_VIOLET_COLOR, APP_WHITE_COLOR } from "./assets/constants/Colors";
// import { useMediaQuery } from "@mui/material";
import moment from "moment";
import { IS_LOGGED_IN, LOCAL_STORAGE, REFRESH_TOKEN_EXPIRY_TIME } from "./assets/constants/BrowserStorageKeys";
import { getSecureItemFromSpecificStorage } from "./lib/BrowserStorageAccessMiddleware";
import ShowToast from "./components/ToastComponent";
import { DARK, LIGHT, TOAST_ERROR } from "./assets/constants/Constants";
import CircularProgressLoader from "./components/CircularProgressLoader";

initializeI18nAndThenAppendCustomerSpecificStylesheet();

const App = () =>  {
  const [isOffline, setIsOffline] = useState( !navigator.onLine );
  const prefersDarkMode = false; //useMediaQuery('(prefers-color-scheme: dark)');
  const [showLoader, setShowLoader] = useState(false);
  const { t } = useTranslation();
  const [cancelTransactionHandler, setCancelTransactionHandler] = useState(null);

  const handleOnlineStatus = () => setIsOffline(false);
  const handleOfflineStatus = () => setIsOffline(true);

  useEffect(() => {
    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOfflineStatus);
    window.addEventListener('click', checkLoginAndTokenExpiry);

    return () => { // Cleanup function for event listeners
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOfflineStatus);
      window.removeEventListener('click', checkLoginAndTokenExpiry);
    };
  }, []); // Empty dependency array to run effect only once


  const darkTheme = createTheme({
    palette: {
      mode: prefersDarkMode ? DARK : LIGHT, // Handle dark mode state on toggle
      background: {
        default: prefersDarkMode ? APP_DARK_PURPLE_COLOR : APP_WHITE_COLOR,
        primary: prefersDarkMode ? APP_ENGLISH_VIOLET_COLOR : APP_WHITE_COLOR,

      },
      text : {
        primary: prefersDarkMode ? APP_WHITE_COLOR : APP_DARK_PURPLE_COLOR, 
        secondary : prefersDarkMode ? APP_DARK_PURPLE_COLOR : APP_WHITE_COLOR
      },
    }
  });

  const checkLoginAndTokenExpiry = async () => {
    const isLoggedIn = getSecureItemFromSpecificStorage(LOCAL_STORAGE,IS_LOGGED_IN);
    const refreshExpiryAt = await getSecureItemFromSpecificStorage(LOCAL_STORAGE, REFRESH_TOKEN_EXPIRY_TIME);
    const now = moment.utc();
    const refreshTokenExpiryTime = moment.utc(refreshExpiryAt);
  
    if (isLoggedIn && now.isAfter(refreshTokenExpiryTime)) {
        clearLocalStorageForUser();
        ShowToast(t('sessionExpired'), TOAST_ERROR);
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
            window.location.href = '/';
        }, 3000); // Adjust the delay as necessary (3000ms = 3 seconds)
    }
  };
  

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseLine />
      <BrowserRouter>
        <RouterComponent theme={darkTheme} 
          onLogout={cancelTransactionHandler} 
          setCancelTransactionHandler={setCancelTransactionHandler}/>
      </BrowserRouter>
      { isOffline && <ConnectionLost /> }
      {showLoader && <CircularProgressLoader message={t('redirectToLogin')} />}
    </ThemeProvider>
  );
}

export default App;

